import { render, staticRenderFns } from "./question-modal.vue?vue&type=template&id=cc823bc2&"
import script from "./question-modal.vue?vue&type=script&lang=js&"
export * from "./question-modal.vue?vue&type=script&lang=js&"
import style0 from "./question-modal.vue?vue&type=style&index=0&id=cc823bc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports